// export const logout = ( state ) => {
// }

export const setOutputs = (state, outputs) => {
    state.outputs = outputs
}

export const setOutputsSelectable = (state, outputs) => {
    state.outputsSelectable = outputs
}

export const setOutputSelect = ( state, output ) => {
    state.outputSelect = output
}


export const setOutputsPaginated = (state, outputsPaginatedData) => {
    state.outputsPaginatedData = outputsPaginatedData
}

export const setOutputDetail = (state, output) => {
    state.output = output
}

export const saveNewOutputs = (state, output) => {
    state.outputs.unshift(output)
    state.createdData = output;
}

export const saveUpdatedOutput = (state, output) => {
    state.outputs.unshift(output)
    state.updatedData = output;
}

export const setDeleteOutput = (state, output) => {
    state.outputsPaginatedData.data.filter(x => x.id !== output.id);
    state.deletedData = output
}

export const setOutputIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setOutputIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setOutputIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setOutputIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}

export const setOutputIsCancelating = (state, isCancelating) => {
    state.isCancelating = isCancelating
}

export const setCancelOutput = (state, output) => {
    state.cancelatedData = output;
}
